/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

interface IFormDialogProps {
  children: React.ReactNode;
  handleClose: Function;
  dialogTitle: string;
  dialogAction1: React.ReactNode;
  dialogAction2: React.ReactNode;
  dialogLoader?: React.ReactNode;
  openModal: boolean;
  maxWidth?: "lg" | "md" | "sm" | "xl" | "xs" | false;
  height?: string;
}

const FormDialog = (props: IFormDialogProps) => {
  const {
    children,
    dialogTitle,
    dialogAction1,
    dialogAction2,
    dialogLoader,
    openModal,
    maxWidth,
    height,
  } = props;
  return (
    <Dialog
      classes={{ paper: height }}
      open={openModal}
      fullWidth
      maxWidth={maxWidth}
    >
      <DialogTitle id="form-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        {dialogLoader}
        {dialogAction1}
        {dialogAction2}
      </DialogActions>
    </Dialog>
  );
};

export default FormDialog;
